import { render, staticRenderFns } from "./RefundLogisticsForm.vue?vue&type=template&id=d0997688&scoped=true&"
import script from "./RefundLogisticsForm.vue?vue&type=script&lang=js&"
export * from "./RefundLogisticsForm.vue?vue&type=script&lang=js&"
import style0 from "./RefundLogisticsForm.vue?vue&type=style&index=0&id=d0997688&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0997688",
  null
  
)

export default component.exports